import React from 'react';
import { useT } from 'client/i18n/hooks/useT';

export function PodcastBloomerIcon({
  width = '100%',
}: {
  width?: string | number;
}) {
  const t = useT();
  return (
    <svg
      width={width}
      viewBox="0 0 346 318"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={t(
        'HomePage.PodcastBloomerIcon.IconAriaLabel',
        'An illustration of a plant and a clock, with the caption: Plant Passion + Patience = Late Bloomer',
        'Anchor podcast title suggestion image screenreader information'
      )}
      style={{ userSelect: 'none' }}
    >
      <g fill="none" fillRule="evenodd">
        <path
          d="M122.06 81.64c-3.07-14.89 1.47-31.06 11.76-42.03-1.82 7.23-1.68 16.33-1.42 22.5a83.88 83.88 0 006.95 30.32c1.06 2.4 2.28 4.83 4.33 6.5 2.03 1.65 5.06 2.37 7.27 1 2.16-1.34 2.93-4.19 2.58-6.72-.37-2.52-1.66-4.83-2.82-7.1a106.1 106.1 0 01-10.12-29.44c-1.03-5.38.12-15.42-2.2-21.33 19.54-16.17 49.46-17 69.65-33.1l6.84 18.59a36.82 36.82 0 01-9.6 18.3c-4.7 4.82-13.15 8.19-8.89 16.76 2 3.98 6.92 6.3 11.19 5.19 5.37-1.37 8.47-6.98 9.98-12.36 1.5-5.33 2-10.98 1.5-16.55.78 2.08 1.52 4.15 2.3 6.22 4.15 11.3 8.36 22.92 8.46 34.92.15 19.72-12 38.86-29.77 46.99-30.02 13.72-71.14-5.4-78-38.66zm53.7-59.42c-1.3.9-1.9 2.58-2.29 4.15a24.5 24.5 0 00.1 11.41c.65 2.63 2.42 5.63 5.1 5.4 1.45-.12 2.67-1.23 3.28-2.54.62-1.32.72-2.81.72-4.29.04-2.78-.81-18.42-6.9-14.13zm10.9 59.98c2.46 1.75 5.6 2.24 8.58 1.9 2.97-.36 5.76-1.5 8.43-2.84a59.7 59.7 0 0013.78-9.6c1.19-1.08 2.34-2.3 2.87-3.8.52-1.52.18-3.47-1.16-4.38-1.79-1.22-4.15-.08-6.06.92-5.63 3-12.15 5.13-18.6 5.5-4.45.25-10.5-1.89-11.47 4.54-.44 2.97 1.15 6.03 3.63 7.76zm-30.33-12.22c1.26 3.17 3.73 6.7 6.61 6.05 1.53-.35 2.59-1.87 3.02-3.54.42-1.67.32-3.48.23-5.26-.35-5.85 1.5-38.5-8.2-34.05-9.28 4.22-4.87 28.74-1.66 36.8z"
          fill="#185941"
          fillRule="nonzero"
        />
        <path
          d="M169.55 258.35l9.7-3.65-4.85 1.8 4.85-1.8c-3.2-7.6-10.28-28.54-14.17-53.76-2.82-18.43-3.64-36.48-2.37-53.62 1.56-21.35 6.3-41.35 14.16-59.47l-9.84-5.52c-8.33 19.3-13.38 40.54-15.01 63.18a252.13 252.13 0 002.57 56.43c5.09 32.99 14.56 55.47 14.96 56.41z"
          fill="#185941"
          fillRule="nonzero"
        />
        <path
          d="M168.7 98.62c-1.6 4.6-3.97 9.89-8.74 10.76 1.5-.26 5.76-17.5 6.54-19.69a545.6 545.6 0 017.9-21.03c5.3-13.27 10.54-27.38 17.75-39.7 1 4.47-3.16 11.61-4.65 15.94-2.05 5.84-4.06 11.68-6.12 17.51-4.24 12.08-8.46 24.15-12.67 36.21z"
          fill="#103A29"
          fillRule="nonzero"
        />
        <path
          d="M336.57 163c-.35-1-.72-1.99-1.14-2.99a25.97 25.97 0 00-15.39-7.9c-2.23-.28-4.93-.58-5.84-2.63-.95-2.11 1.07-4.61 3.34-5.06 2.61-.52 6.8.75 10.15 2.37a50.74 50.74 0 00-13.92-12.25c-17.73-10.53-41.72-9.29-58.28 3-7.1 5.26-12.91 12.49-15.68 20.88-2.76 8.42-2.26 18.02 2.15 25.7 4.41 7.66 12.93 13.02 21.76 12.84 6.98-.14 13.49-3.53 19.15-7.62 5.64-4.1 10.73-8.99 16.54-12.82 5.84-3.84 12.73-6.64 19.65-5.84 7.68.89 11.38 6.14 15.42 11.98 3.44 5 4.99 5.25 5.08-1.4.1-6.18-.94-12.4-3-18.26zm-65.4-14.88c-.23-3.17 5.76-7.62 7.92-9.12a44.06 44.06 0 0116.18-6.9c.92-.2 1.9-.35 2.8-.11.9.24 1.74 1.04 1.75 1.99.01 1.16-1.12 1.95-2.11 2.54a250.64 250.64 0 01-16.73 9c-2.33 1.15-9.54 6.38-9.82 2.6zm-3.97 34.66c-2.35-.04-4.78-.34-6.9-1.36-2.13-1.03-3.93-2.91-4.46-5.21-.52-2.32.5-5 2.64-6.02 1.52-.72 3.3-.53 4.87.02 1.56.57 2.97 1.5 4.43 2.3 5.57 3.06 10.94 2.6 16.75 4-1.43 5.33-13.04 6.33-17.33 6.27zm42.96-15.03c.2 4.56-3.9 1.15-6.48.32a27.4 27.4 0 00-11.45-1.12c-2.4.28-4.79.91-7.2.8-2.42-.1-5-1.06-6.2-3.17-1.68-2.95.12-6.93 3.08-8.59 2.94-1.65 6.59-1.47 9.88-.72 4.88 1.12 18.12 6.2 18.37 12.47z"
          fill="#185941"
          fillRule="nonzero"
        />
        <path
          d="M178.33 257.48l-6.26-1.44a130.9 130.9 0 0143.44-70.63 129.3 129.3 0 0122.57-15.05l2.98 5.69a123.54 123.54 0 00-21.44 14.3 124.08 124.08 0 00-41.3 67.13z"
          fill="#185941"
          fillRule="nonzero"
        />
        <path
          d="M333.8 173.82c-.54-.94-1-1.88-1.62-2.77-.55-.92-1.19-1.77-1.8-2.63a46.42 46.42 0 00-4.22-4.72 49.23 49.23 0 00-4.86-3.97 46.88 46.88 0 00-5.36-3.17c-.96-.44-1.86-.9-2.84-1.28-.95-.42-1.94-.73-2.9-1.09a49.24 49.24 0 00-18.38-2.29c-2.07.12-4.15.34-6.21.65-2.06.33-4.1.77-6.13 1.28a84.36 84.36 0 00-6 1.82c-.99.37-1.96.73-2.94 1.12-.99.37-1.94.8-2.92 1.2-7.73 3.41-15 7.93-22.07 12.83a88.94 88.94 0 0120.91-15.25c.98-.49 1.94-.99 2.94-1.43.98-.46 2-.87 3.02-1.3 2.04-.8 4.11-1.53 6.22-2.15a64.6 64.6 0 016.42-1.47c2.17-.35 4.36-.6 6.58-.75 2.22-.1 4.42-.08 6.62.05 2.22.18 4.4.48 6.57.93 2.17.5 4.3 1.1 6.38 1.88 2.08.8 4.08 1.76 5.99 2.84.94.56 1.9 1.13 2.8 1.78.91.61 1.78 1.3 2.65 1.98 1.69 1.4 3.28 2.94 4.72 4.6a37.78 37.78 0 013.8 5.35c.5.96 1.05 1.9 1.46 2.9.46 1.03.8 2.05 1.18 3.06z"
          fill="#103A29"
          fillRule="nonzero"
        />
        <path
          d="M68.63 225.66c.2-.68.43-1.36.68-2.05 2.59-3 6.23-5.07 10.1-5.74 1.5-.25 3.3-.53 3.85-1.94.58-1.44-.85-3.07-2.38-3.3-1.77-.28-4.55.7-6.75 1.87a34.1 34.1 0 019-8.63c11.6-7.58 27.74-7.42 39.2.38 4.93 3.34 9.03 8.03 11.12 13.6 2.1 5.59 2.03 12.06-.71 17.34-2.75 5.29-8.31 9.13-14.24 9.25-4.7.1-9.16-2-13.07-4.58-3.9-2.6-7.46-5.74-11.47-8.16-4.03-2.41-8.73-4.1-13.36-3.37-5.12.81-7.46 4.45-10 8.5-2.18 3.45-3.2 3.66-3.46-.8-.24-4.16.28-8.38 1.5-12.37zm43.48-11.85c.06-2.14-4.08-4.97-5.58-5.92a29.6 29.6 0 00-11.05-4.18 4.14 4.14 0 00-1.88 0c-.6.2-1.14.75-1.12 1.4.02.77.8 1.27 1.49 1.64 3.76 2.01 7.59 3.87 11.48 5.59 1.6.7 6.58 4.02 6.66 1.47zm3.65 23.2a11 11 0 004.6-1.12 5.41 5.41 0 002.84-3.62c.28-1.58-.48-3.36-1.95-3.98a4.33 4.33 0 00-3.26.15c-1.03.43-1.95 1.1-2.9 1.68-3.66 2.21-7.28 2.06-11.14 3.15 1.11 3.55 8.94 3.9 11.8 3.73zm-29.27-8.9c0 3.07 2.66.66 4.36.03 2.44-.9 5.06-1.27 7.66-1.08 1.62.13 3.24.48 4.85.34 1.62-.14 3.33-.85 4.08-2.3 1.04-2.04-.28-4.66-2.31-5.7-2.02-1.03-4.47-.8-6.65-.2-3.25.89-12 4.68-11.99 8.9z"
          fill="#185941"
          fillRule="nonzero"
        />
        <path
          d="M177.54 284.75l4.16-1.15a88.16 88.16 0 00-31.16-46.28 86.9 86.9 0 00-15.58-9.49l-1.84 3.91a83.03 83.03 0 0114.8 9.02 83.57 83.57 0 0129.62 43.99z"
          fill="#185941"
          fillRule="nonzero"
        />
        <path
          d="M70.8 232.86c.33-.65.62-1.3 1-1.91.35-.64.75-1.22 1.15-1.82a31.35 31.35 0 012.7-3.3c.98-1 2.04-1.94 3.14-2.8a31.5 31.5 0 013.51-2.29c.63-.32 1.22-.65 1.87-.94.63-.3 1.28-.54 1.91-.8a32.92 32.92 0 0112.28-2.07c1.39.02 2.79.11 4.18.26a49.2 49.2 0 018.23 1.75c.68.22 1.34.43 2 .67.68.22 1.34.47 2 .73 5.3 2.07 10.3 4.9 15.19 8a59.77 59.77 0 00-14.48-9.67c-.67-.3-1.33-.6-2.01-.87-.67-.29-1.37-.54-2.07-.8-1.39-.48-2.8-.9-4.23-1.27-1.43-.35-2.9-.6-4.35-.8a48.65 48.65 0 00-4.44-.32c-1.5-.01-2.97.07-4.44.22-1.49.18-2.94.44-4.39.8-1.44.4-2.85.86-4.22 1.45-1.38.6-2.7 1.3-3.95 2.07-.61.41-1.24.82-1.82 1.29-.6.43-1.16.92-1.73 1.4a25.42 25.42 0 00-5.44 6.93c-.3.66-.64 1.31-.9 2-.27.7-.48 1.4-.7 2.09z"
          fill="#103A29"
          fillRule="nonzero"
        />
        <path
          d="M203.42 318h-56.84c-8.56 0-15.58-7.2-15.58-15.99V270c0-8.79 7.02-15.99 15.58-15.99h56.84c8.56 0 15.58 7.2 15.58 15.99V302c-.02 8.79-7.02 15.99-15.58 15.99z"
          fill="#97E0CE"
          fillRule="nonzero"
        />
        <path
          d="M170.37 309.77c-12.15 2.22-31.43-.25-39.37-8.15v.05c0 8.97 7.02 16.33 15.59 16.33h56.82c8.57 0 15.59-7.36 15.59-16.33v-5.54c-23.74-5.44-30.68 10.33-48.63 13.64z"
          fill="#185941"
          fillRule="nonzero"
          opacity=".5"
        />
        <path
          d="M300.44 89.42A43.9 43.9 0 00344.3 45.5a43.9 43.9 0 00-43.86-43.93 43.9 43.9 0 00-43.85 43.93 43.9 43.9 0 0043.85 43.93z"
          fill="#97E0CE"
          fillRule="nonzero"
        />
        <path
          d="M300.44 91a45.08 45.08 0 01-32.1-13.32 45.24 45.24 0 01-13.3-32.17 45.24 45.24 0 0113.3-32.16A45.02 45.02 0 01300.43 0a45.08 45.08 0 0132.11 13.33 45.24 45.24 0 0113.3 32.16 45.24 45.24 0 01-13.3 32.17A45.02 45.02 0 01300.45 91zm0-87.88a42.04 42.04 0 00-29.91 12.4 42.1 42.1 0 00-12.39 29.97c0 11.33 4.41 21.96 12.39 29.97 8 8 18.6 12.4 29.91 12.4 11.31 0 21.92-4.41 29.92-12.4a42.1 42.1 0 0012.38-29.97c0-11.33-4.4-21.96-12.38-29.97a42 42 0 00-29.92-12.4z"
          fill="#185941"
          fillRule="nonzero"
        />
        <path
          d="M278.25 37.92l3 4.45 15.6 3.38v-.26c0-.84.3-1.68.84-2.32l-14.34-6.93-5.1 1.68zM291.33 72.28l.36.24L299.5 49a3.1 3.1 0 01-.4-.14l-7.77 23.43z"
          fill="#185941"
          fillRule="nonzero"
        />
        <path
          d="M296.85 45.75a3.61 3.61 0 003.85 3.34 3.61 3.61 0 00-.52-7.2 3.58 3.58 0 00-3.33 3.6v.26z"
          fill="#24203F"
          fillRule="nonzero"
        />
        <path
          fill="#185941"
          fillRule="nonzero"
          d="M299.23 75.38l-.03 8.19v.04h2.32v-8.23zM270.55 46.63V44.3H262.3v2.32h.04zM317.62 75.47a1.14 1.14 0 10-2.24-.41 1.14 1.14 0 002.24.41zM271.63 29.37a1.14 1.14 0 10-2.24-.41 1.14 1.14 0 002.24.4zM285.35 75.44a1.14 1.14 0 10-2.24-.41 1.14 1.14 0 002.24.41zM271.66 61.93a1.14 1.14 0 10-2.24-.4 1.14 1.14 0 002.24.4zM301.62 15.78l-.04-8.2v-.05l-2.31.02v.02l.04 8.21zM330.46 44.37l.02 2.3 8.2-.04h.01l-.02-2.32h-.02zM285.45 16.2a1.14 1.14 0 10-2.25-.4 1.14 1.14 0 002.25.4zM331.7 62.02a1.14 1.14 0 10-2.24-.4 1.14 1.14 0 002.24.4zM317.73 16.02a1.14 1.14 0 10-2.24-.4 1.14 1.14 0 002.24.4zM331.49 29.45a1.14 1.14 0 10-2.25-.4 1.14 1.14 0 002.25.4z"
        />
        <text
          fontSize="20"
          fontWeight="bold"
          fill="#FFF"
          dangerouslySetInnerHTML={{
            __html: t(
              'HomePage.PodcastBloomerIcon.PlantsWordMix',
              '<tspan x="0" y="19">Plant Passion +</tspan><tspan x="0" y="49">Patience =</tspan>',
              'Anchor podcast title suggestion image text'
            ),
          }}
        />
        <text
          fontSize="60"
          fontWeight="800"
          letterSpacing="-.7"
          fill="#97E0CE"
          dangerouslySetInnerHTML={{
            __html: t(
              'HomePage.PodcastBloomerIcon.PlantsTitleIdea',
              '<tspan x="0" y="142">Late</tspan><tspan x="0" y="202">Bloomer</tspan>',
              'Anchor podcast title suggestion image text'
            ),
          }}
        />
      </g>
    </svg>
  );
}
